import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_guest/')({
  beforeLoad: () => {
    throw redirect({ to: '/signin' });
  },
});
